<!-- 
    FORM CADASTRO DA AGENDA DO USUARIO
-->

<script>
import Vue from 'vue';
import { apiORDSpost, apiORDSdelete, apiDownloadPDF, apiEmailPDF } from '../shared/api-functions'
import { SysVars } from '../main';
import apiCrm from '../api/api-crm.js'

import CrmPipeline from './crm-pipeline'
import AgendaForm from '../forms/agenda-form'
import AnexosForm from '../components/anexos-form'
import CrmNegocioNovoForm from './crm-negocio-novo-form'
import CrmNegocioMotivoForm from './crm-negocio-motivo-form'
import CrmOrgNovoForm from './crm-org-novo-form'
import CrmPessoaNovoForm from './crm-pessoa-novo-form'
import CrmNegocioParticipantes from './crm-negocio-participantes'
import CrmNegocioSeguidores from './crm-negocio-seguidores'
import CrmNegocioAgenda from './crm-negocio-agenda'
import CrmNotes from './crm-notes'
import FvPedidoForm from '../forms-fv/fv-pedido-form'
import CrmEmail from './crm-email'

export default {
    props: {
        index: '',
    },
    
    components: {
        AgendaForm, AnexosForm, CrmPipeline, CrmNegocioNovoForm, CrmNegocioMotivoForm, CrmOrgNovoForm, 
        FvPedidoForm, CrmEmail, CrmPessoaNovoForm, CrmNegocioParticipantes, CrmNegocioSeguidores, CrmNegocioAgenda, 
        CrmNotes
    },

    data () {
        return {
            errmessages: null,
            error: false,
            metadata: this.$store.getters.getEntities.metadata,
            modalDelete: false,
            activeTab: 0,

            showFormNegocio: false,
            showFormMotivo: false,
            showFormOrg: false,
            showFormOrcamento: false,
            showFormPessoa: false,

            negociocrm: null,

            showCodemail: null,

            paramsNegocio: null,

            usuarioOptions: [],

            incluirOrcamento: false,
            codpedv: null, 
            showFormEmail: false,

            anexos: [], //lista de anexos do pedido
            notes: [],

            novoEmail: false,

            seguidores: [],
            showFormSeguidores: false,

            participantes: [],
            showFormParticipantes: false,

            texto: null,

            tabs: [
                { title: null, help: 'Principal', icon: 'fa-paperclip', count: 0 },
                { title: null, help: 'E-mails', icon: 'fa-envelope', count: 0 },
                { title: null, help: 'Atividades Realizadas', icon: 'fa-calendar', count: 0 },
                { title: null, help: 'Histórico de Alterações', icon: 'fa-exchange', count: 0 },
            ],

        }
    },

    mixins: [apiCrm],  //ROTINAS DO CRM

    computed: {
        permiteAlteracao: function () {
            return this.negociocrm.excluido!='S'
        },

        permiteDesvincularPessoa: function () {
            return this.negociocrm.codorg

        },
        tabHistorico: function () {
            return this.activeTab=='3'
        },

        tabPrincipal: function () {
            return this.activeTab=='0'
        },

        tabEmails: function () {
            return this.activeTab=='1'
        },

        tabAgenda: function () {
            return this.activeTab=='2'
        },

        nomeUsuario: function () {
            if (this.negociocrm && this.negociocrm.usuario.length > 0)
              return this.negociocrm.usuario[0].nome
            else 
              return null
        },

        organizacao: function () {
            if (this.negociocrm && this.negociocrm.organizacao.length > 0)
              return this.negociocrm.organizacao[0]
            else 
              return null
        },

        pessoa: function () {
            if (this.negociocrm && this.negociocrm.pessoa.length > 0)
              return this.negociocrm.pessoa[0]
            else 
              return null
        },

        tag: function () {
            if (this.negociocrm && this.negociocrm.tag.length > 0)
              return this.negociocrm.tag[0]
            else 
              return null
        },

        agendaList: function () {
            return this.negociocrm.agenda.filter((obj) => {
                return obj.concluida === 'S'
            })
        },

        agendaListPlanejada: function () {
            return this.negociocrm.agenda.filter((obj) => {
                return obj.concluida != 'S'
            })
        },

        orcamentoList: function () {
            return this.negociocrm.orcamentos
        },

        hist: function () {
            return this.$store.getters.getNegocioHist
        },

        emailList: function () {
            return this.$store.getters.getNegocioEmails
        },

        etapaList: function () {
            if (this.$store.getters.getConfigCrm.etapas)
              return this.$store.getters.getConfigCrm.etapas
            else
              return []
        },

        funilList: function () {
            if (this.$store.getters.getConfigCrm)
                return this.$store.getters.getConfigCrm.funil
            else
                return []
        },

        funil: function () {
            let funil = this.funilList[0]
            funil.etapas = this.etapaList.filter((option) => {
                return option.codfunil == funil.codfunil
            })
            return funil
        },

        botaoPerdidoGanho () {
            return this.negociocrm.stnegocio == 'A' && this.negociocrm.excluido != 'S'
        },

        botaoAlterar () {
            return this.negociocrm.stnegocio == 'A' && this.negociocrm.excluido != 'S'
        },

        botaoReabrir () {
            return this.negociocrm.excluido == 'S'
        },

        botaoExcluir () {
            return this.negociocrm.stnegocio == 'A' && this.negociocrm.excluido != 'S'
        }

    },

    methods: {
        changeTab (idx) {
            this.activeTab = idx
            if (this.tabEmails)
              this.loadEmails()
        },

        statusColor: function (value) {
            if (value == 'G') {
                return 'badge-green'
            } else
                return 'badge-red'
        },

        handleStyle(color) {
            if (color)
              return 'color: white; background-color: ' + color;
            else 
              return ''
        },

        handleSalvar () {
            var valido = true;

            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$erpToastError('Corrija os erros de preenchimento para continuar!')
                } else if (valido) {
                    this.apiPost()
                }
            })

        },

        handleGanho () {
            let obj = { codnegocio: this.negociocrm.codnegocio, stnegocio: 'G' }
            this.apiNegocio(obj, this.negociocrm.codnegocio, this.callBackNegocio)
        },

        handlePerdido () {
            // abrir motivo para digitacao
            this.showFormMotivo = true
        },

        closeFormMotivo (negocio) {
            this.showFormMotivo = false
            if (negocio){
                let obj = { codnegocio: this.negociocrm.codnegocio, stnegocio: 'P', codmotivo: negocio.codmotivo, textomotivo: negocio.textomotivo }
                this.apiNegocio(obj, this.negociocrm.codnegocio, this.callBackNegocio)
            }
        },

        closeFormOrg (org) {
            this.showFormOrg = false
            if (this.incluirOrcamento && org) {
                this.negociocrm.organizacao = [ org ]
                this.incluirOrcamento = false
                this.handleIncluirOrcamento()
            }
        },

        handleExcluir () {
            if (confirm("Confirma a exclusão?")) {
                this.apiNegocioDelete(this.negociocrm.codnegocio, this.callBackNegocio)
            }
        },

        handleReabrir () {
            let obj = { codnegocio: this.negociocrm.codnegocio, stnegocio: 'A' }
            this.apiNegocio(obj, this.negociocrm.codnegocio, this.callBackNegocio)
        },

        callBackNegocio (data) {
            if (data) {
                this.negociocrm = data
            }
        },

        closeForm () {
            if (this.$route.params.codnegocio)
                this.$router.go(-1)
            else
                this.$emit('closeform')
        },

        closeOrcamento (orcamento) {
            this.showFormOrcamento = false
        },

        closeNovoNegocio (negocio) {
            if (negocio)
              this.negociocrm = negocio
            this.showFormNegocio = false
        },

        handleChangeEtapa (etapa) {
            this.negociocrm.codetapa = etapa.codetapa
        },




        loadEmails () {
            this.showCodemail = null
            this.$store.dispatch('loadNegocioEmails', { id: this.negociocrm.codnegocio } )
        },

        async loadData () {
            await this.$store.dispatch('loadConfigCrm', this)
            let codnegocio = this.index
            if (this.$route.params && this.$route.params.codnegocio)
              codnegocio = this.$route.params.codnegocio
            await this.$store.dispatch('loadNegocioHist', { id: codnegocio } )
            await this.$store.dispatch('loadNegocio', { id: codnegocio } )
            if (this.$store.getters.getNegocio) {
                this.negociocrm = {...this.$store.getters.getNegocio}
                this.notes = this.negociocrm.notes
                this.seguidores = this.negociocrm.seguidores
                this.anexos = this.negociocrm.anexos
                this.participantes = this.negociocrm.participantes
            }

            this.loadEmails()

            //CONTADORES
            this.tabs[3].count = this.hist.length
            // this.tabs[1].count = this.anexos.length
            this.tabs[2].count = this.agendaList.length
            // this.tabs[4].count = this.orcamentoList.length
        },

        handleEditNegocio () {
            this.paramsNegocio = { negocio: this.negociocrm, alterarOutrosCampos: true }
            this.showFormNegocio = true;
        },

        handleEditNegocioPessoa () {
            this.paramsNegocio = { negocio: this.negociocrm, alterarPessoa: true }
            this.showFormNegocio = true;
        },

        handleEditNegocioOrg () {
            this.paramsNegocio = { negocio: this.negociocrm, alterarOrg: true }
            this.showFormNegocio = true;
        },


        /////////////////////////////////// ORGANIZACAO
        handleDesvincularOrg () {
            if (this.orcamentoList.length > 0) {
                this.$showMessage('Não Permitido', 'Não é permitido desvincular organização quando o negócio possui orçamento vinculado.', 'warning')
                return
            }
            let obj = { codnegocio: this.negociocrm.codnegocio, codorg: null }
            this.organizacao = null
            this.apiNegocio(obj, this.negociocrm.codnegocio, this.callBackNegocio)
        },

        handleShowOrg () {
          this.$router.push('/crm/organizacao/' + this.negociocrm.codorg)
        },

        handleEditarOrg () {
            this.incluirOrcamento = false
            this.showFormOrg = true
        },

        /////////////////////////////////// PESSOA DE CONTATO
        handleDesvincularPessoa () {
            let obj = { codnegocio: this.negociocrm.codnegocio, codpessoa: null }
            this.pessoa = null
            this.apiNegocio(obj, this.negociocrm.codnegocio, this.callBackNegocio)
        },

        handleShowPessoa () {
          this.$router.push('/crm/pessoa/' + this.pessoa.codpessoa)
        },

        handleEditarPessoa () {
            this.showFormPessoa = true
        },

        closeFormPessoa (pessoa) {
            this.loadData()
            this.showFormPessoa = false
        },

        /////////////////////////////////// EMAILS
        handleNovoEmail () {
            this.novoEmail = true
        },

        closeEmail (email, novo) {
            if (novo) {
                this.emailList.splice(0, 0, email)
            } else
            if (email) {
                let list = this.emailList.filter((obj) => {
                    return obj.codemail == email.codemail && obj.visualizado == 'N'
                })
                if (list.length > 0)
                    list[0].visualizado = 'S'
            }
            this.showCodemail = null
            this.novoEmail = null
        },


        /////////////////////////////////// SEGUIDORES
        handleIncluirSeguidor () {
            this.showFormSeguidores = true
        },
        handleCloseSeguidor () {
            this.seguidores = this.negociocrm.seguidores
            this.showFormSeguidores = false
        },
        /////////////////////////////////// FIM SEGUIDORES


        /////////////////////////////////// PARTICIPANTES DO NEGOCIO
        handleIncluirParticipante () {
            this.showFormParticipantes = true
        },
        handleCloseParticipante () {
            this.participantes = this.negociocrm.participantes
            this.showFormParticipantes = false
        },
        /////////////////////////////////// FIM PARTICIPANTES



        /////////////////////////////////// ATIVIDADES  / AGENDA
        handleIncluirAgenda (codagenda) {
            //abre a tela de edicao
            this.$refs.agenda.handleIncluirAgenda()
            // this.crud = SysVars.crudI 
            // this.codagenda = null
            // this.showFormAgenda = true;
        },
        // handleEditAgenda (codagenda) {
        //     //abre a tela de edicao
        //     this.crud = SysVars.crudU //operacao de edicao
        //     this.codagenda = codagenda
        //     this.showFormAgenda = true; //exibe o form de agenda
        // },
        updateAgenda (agenda) {
            this.tabs[3].count = this.agendaList.length

        //     this.showFormAgenda = false

        //     if (agenda) {
        //         let index = null
        //         for (var x = 0; x < this.negociocrm.agenda.length; x++) {
        //             if (this.negociocrm.agenda[x].codagenda == agenda.codagenda)
        //               index = x
        //         }
        //         if (index >= 0) {
        //             this.negociocrm.agenda[index].concluida = agenda.concluida
        //         }
        //         else
        //             this.negociocrm.agenda.push(agenda)
        //     }

        },

        // handleDeleteAgenda (codagenda) {
        //     let index = null
        //     for (var x = 0; x < this.negociocrm.agenda.length; x++) {
        //         if (this.negociocrm.agenda[x].codagenda == codagenda)
        //           index = x
        //     }
        //     if (confirm("Confirma a exclusão?")) {
        //         this.apiAgendaDelete(codagenda).then(
        //             this.negociocrm.agenda.splice(index, 1)
        //         )
        //     }
        // },


        /////////////////////////////////// FIM ATIVIDADES




        /////////////////////////////////// ANEXOS
        handleAnexarDocumento() {
            //ANEXAR DOCUMENTOS
            this.$nextTick(function () {
                this.$refs.anexos.handleClickAdiciona()
            })
        },
        handleChangeAnexos(anexosList) {
            //ATUALIZA A LISTA DE ANEXOS
            this.anexos = anexosList
            this.tabs[1].count = this.anexos.length
        },
        /////////////////////////////////// FIM ANEXOS




        /////////////////////////////////// ORÇAMENTOS

        handleEditOrcamento (codpedv) {
            //abre a tela de edicao
            //this.crud = SysVars.crudU //operacao de edicao
            //this.codpedv = codpedv
            //this.showFormOrcamento = true;
            this.$router.push('/crm/negocio/' + this.negociocrm.codnegocio + '/orcamento/' + codpedv)

        },

        handleIncluirOrcamento () {
            //abre a tela de inclusao de orçamento
            if (!this.organizacao.codpart) {
                //verifica se a organizacao está associada a um cliente
                this.crud = SysVars.crudI
                this.incluirOrcamento = true
                this.showFormOrg = true
                return 
            }
            // this.crud = SysVars.crudI
            // this.codpedv = null
            // this.showFormOrcamento = true;
            this.$router.push('/crm/negocio/' + this.negociocrm.codnegocio + '/orcamento/novo')
        },

        handleImprimir (codpedv) {
            apiDownloadPDF(this, 'print/sales/' + codpedv)
        },

        handleEmailOrcamento (codpedv) {
            // ENVIA EMAIL
            this.showFormEmail = true
            this.codpedv = codpedv
        },

        closeFormEmail() {
            this.showFormEmail = false
        },

        async handleSendEmail(data) {
            //cahamda para envio de email do pedido
            this.closeFormEmail()
            const email = await apiEmailPDF(this, 'pedv/' + this.codpedv, data)
        },

        /////////////////////////////////// FIM ORÇAMENTOS

    },

    watch: {
        emailList () {
            this.tabs[1].count = this.$store.getters.getNegocioEmails.length
        }

    },

    mounted () {
        this.$nextTick(function () {
            if (this.$refs.usuario) {
               this.$refs.usuario.focus()
            }
        })
    },

    created () {
        this.loadData()
    }

}

</script>

<template>
<!-- <div class="deal-form-side"> -->
<div class="">
<div class="deal-form mb-2" v-if="negociocrm">
    <div class="deal-form-1">
        <div class="deal-form-2">
            <div class="col-12 p-3">
                <!-- <button type="button" class="close" style="" @click="closeForm()">
                    <span aria-hidden="true">&times;</span>
                </button> -->
                <span v-if="negociocrm.stnegocio=='A'" class="badge badge-gray" style="font-size: 18px">Negócio Aberto</span>
                <span v-if="negociocrm.stnegocio=='G'" class="badge badge-green" style="font-size: 18px">Negócio Ganho</span>
                <span v-if="negociocrm.stnegocio=='P'" class="badge badge-red" style="font-size: 18px">Negócio Perdido</span>

                <span v-if="negociocrm.excluido=='S'" class="badge badge-red">Excluída</span>
                <v-button v-if="botaoPerdidoGanho" class="float-right" label="" title="Marcar negócio como ganho" :success="true" icon="fa-trophy" @click="handleGanho"></v-button>
                <v-button v-if="botaoPerdidoGanho" class="float-right" label="" title="Marcar negócio como perdido"  icon="fa-thumbs-down" @click="handlePerdido"></v-button>
                <v-button v-if="botaoExcluir" class="float-right" label="" title="Excluir este negócio" :danger="true" icon="fa-trash" @click="handleExcluir"></v-button>
                <v-button v-if="botaoAlterar" class="float-right" label="" title="" icon="fa-pencil" @click="handleEditNegocio"></v-button>
                <v-button v-if="botaoReabrir" class="float-right" label="Reabrir" title="Reabrir este contato" icon="" @click="handleReabrir"></v-button>
                <v-button label="Retornar" class="float-right" icon="fa-arrow-left" @click="closeForm()"></v-button>
            </div>
            <div class="col-12 p-3">
                <span class="lbl-deal-title" style="cursor: pointer" @click="handleEditNegocio">{{ negociocrm.titulo }}</span>
            </div>
            <div class="col-12 mb-2">
                <!-- PIPELINE -->
                <crm-pipeline @change="handleChangeEtapa" :negocio="negociocrm" :funil="funil"></crm-pipeline>
            </div>
        </div>
    </div>
</div>
<div id="formorg" class="deal-form" v-if="negociocrm">
    <div class="deal-form-1">
        <div class="deal-form-2">
            <div class="deal-form-3">
                <div class="deal-form-left">
                    <div class="row">
                        <!-- TITULO -->
                        <!-- <div class="col-12 mt-2">
                            <span class="lbl-deal-title" style="cursor: pointer" @click="handleEditNegocio">{{ negociocrm.titulo}}</span>
                            <span v-if="negociocrm.excluido=='S'" class="badge badge-red">Excluída</span>
                            <v-button v-if="botaoGanho" class="float-right" label="" title="Marcar negócio como ganho" :success="true" icon="fa-trophy" @click="handleExcluir"></v-button>
                            <v-button v-if="negociocrm.excluido!='S'" class="float-right" label="" title="Excluir este negócio" :danger="true" icon="fa-trash" @click="handleExcluir"></v-button>
                            <v-button v-if="negociocrm.excluido!='S'" class="float-right" label="" title="" icon="fa-pencil" @click="handleEditNegocio"></v-button>
                            <v-button v-if="negociocrm.excluido=='S'" class="float-right" label="Reabrir" title="Reabrir este contato" icon="" @click="handleReabrir"></v-button>
                        </div> -->
                        <div class="col-12">
                            <div class="w-100">
                                <span class="lbl-list"><i class="fa fa-calendar pr-2" aria-hidden="true"></i> Criado em {{ negociocrm.data | formatDataHoraExtenso }}</span>
                                <span class="lbl-list"><i class="fa fa-hourglass pr-2" aria-hidden="true"></i> Negócio criado há {{ negociocrm.idade_negocio }} dias</span>
                                <span class="lbl-list">Negócio inativo há {{ negociocrm.dias_inativo }} dias</span>
                            </div>
                        </div>
                        <!-- ETIQUETA -->
                        <div class="col-12 mt-3">
                            <v-button v-if="!negociocrm.valor && permiteAlteracao" :link="true" label="Defina um valor para este negócio" @click="handleEditar"></v-button>
                            <span v-else class="lbl-negocio" style="cursor: pointer" @click="handleEditNegocio"> {{ negociocrm.valor | formatValue(2) }} </span>
                            <div v-if="tag">
                                <i class="lbl-deal-subtitle fa fa-tag pr-2" aria-hidden="true"></i> 
                                <span class="tag-input-color" :style="handleStyle(tag.cor)" @click="handleEditNegocio"> {{ tag.descricao }} </span>
                            </div>
                            <v-button v-else :link="true" label="Definir uma etiqueta" icon="fa-tag" @click="handleEditNegocio"></v-button>
                        </div>
                        <!-- ORGANIZACAO -->
                        <div class="col-12 mt-5">
                            <div class="mb-2">
                                <span class="lbl-deal-subtitle">ORGANIZAÇÃO</span>
                                <span class="fa fa-pencil pl-3 float-right" data-toggle="dropdown"></span>
                                <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                                    <a class="dropdown-item pr-3" @click="handleDesvincularOrg"><i class="fa fa-chain-broken pr-2" aria-hidden="true"></i> Desvincular esta organização</a>
                                    <a class="dropdown-item pr-3" @click="handleEditNegocioOrg"><i class="fa fa-exchange pr-2" aria-hidden="true"></i> Trocar organização</a>
                                    <a class="dropdown-item pr-3" @click="handleEditarOrg"><i class="fa fa-pencil pr-2" aria-hidden="true"></i> Alterar dados desta organização</a>
                                    <a class="dropdown-item pr-3" @click="handleShowOrg"><i class="fa fa-search pr-2" aria-hidden="true"></i> Exibir organização</a>
                                </div>
                            </div>
                            <div v-if="negociocrm.codorg" class="w-100">
                                <i class="fa fa-university pr-2" aria-hidden="true"></i>
                                <span class="lbl-deal-subtitle pr-2"> {{ organizacao.nome }} </span>
                                <div class="w-100"></div>
                                <span class="lbl-list" v-if="organizacao.cnpj"> {{ organizacao.cnpj | formatCNPJCPF }} </span>
                                <div class="mb-2"></div>
                                <i class="lbl-deal-subtitle fa fa-tag pr-2" aria-hidden="true"></i> 
                                <span v-if="organizacao.tag.length>0" class="tag-input-color" :style="handleStyle(organizacao.tag[0].cor)"> {{ organizacao.tag[0].descricao }} </span>
                            </div>
                            <div v-if="!negociocrm.codorg && permiteAlteracao" class="w-100">
                                <i class="fa fa-university pr-2" aria-hidden="true"></i>
                                <a class="pr-3" style="cursor: pointer; color: #0091ea;" @click="handleEditNegocioOrg"> Vincular uma organização </a>
                            </div>
                        </div>
                        <!-- PESSOA DE CONTATO -->
                        <div class="col-12 mt-5">
                            <div class="mb-2">
                                <span class="lbl-deal-subtitle">CONTATO</span>
                                <span class="fa fa-pencil float-right" style="cursor: pointer" data-toggle="dropdown"></span>
                                <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                                    <a class="dropdown-item pr-3" @click="handleDesvincularPessoa"><i class="fa fa-chain-broken pr-2" aria-hidden="true"></i> Desvincular esta pessoa</a>
                                    <a class="dropdown-item pr-3" @click="handleEditNegocioPessoa"><i class="fa fa-exchange pr-2" aria-hidden="true"></i> Trocar pessoa</a>
                                    <a class="dropdown-item pr-3" @click="handleEditarPessoa"><i class="fa fa-pencil pr-2" aria-hidden="true"></i> Alterar dados desta pessoa</a>
                                    <a class="dropdown-item pr-3" @click="handleShowPessoa"><i class="fa fa-search pr-2" aria-hidden="true"></i> Exibir pessoa</a>
                                </div>
                            </div>
                            <div v-if="negociocrm.codpessoa" class="w-100">
                                <i class="fa fa-user pr-2" aria-hidden="true"></i>
                                <span class="lbl-deal-subtitle"> {{ pessoa.nome }} </span>
                                <div class="w-100"></div>
                                <span class="lbl-list" v-for="(fone, index) in pessoa.telefones" :key="index"><i class="fa fa-phone pr-2" aria-hidden="true"></i> {{ fone.numero | formatFone }} </span>
                                <div class="w-100"></div>
                                <span class="lbl-list" v-for="(email, index) in pessoa.emails" :key="index"><i class="fa fa-envelope pr-2" aria-hidden="true"></i> {{ email.email }} </span>
                                <div class="mb-2"></div>
                                <i class="lbl-deal-subtitle fa fa-tag pr-2" aria-hidden="true"></i> 
                                <span v-if="pessoa.tag.length>0" class="tag-input-color" :style="handleStyle(pessoa.tag[0].cor)"> {{ pessoa.tag[0].descricao }} </span>
                            </div>
                            <div v-if="!negociocrm.codpessoa && permiteAlteracao"  class="w-100">
                                <i class="fa fa-user pr-2" aria-hidden="true"></i>
                                <a class="pr-3" style="cursor: pointer; color: #0091ea;" @click="handleEditNegocioPessoa"> Vincular uma pessoa de contato </a>
                            </div>
                        </div>
                        <!-- PROPRIETARIO -->
                        <div class="col-12 mt-5">
                            <div class="mb-2">
                                <span class="lbl-deal-subtitle mb-2">PROPRIETÁRIO</span>
                            </div>
                            <div>
                                <a class="lbl pr-2"><i class="fa fa-user-circle pr-2" aria-hidden="true"></i> {{ nomeUsuario }}</a>
                            </div>
                        </div>

                        <!-- DADOS DO NEGOCIO -->
                        <div class="col-12 mt-5">
                            <div class="mb-2">
                                <span class="lbl-deal-subtitle mb-2">DADOS DO NEGÓCIO</span>
                            </div>
                        </div>
                        <div class="col-12">
                            <v-label class="w-100" :metadata-field="metadata.negociocrm.dataprevista"></v-label>
                            <a v-if="!negociocrm.dataprevista && permiteAlteracao" style="cursor: pointer; color: #0091ea;" @click="handleEditNegocio"> Definir uma data </a>
                            <span v-else class="lbl"> <i class="fa fa-flag-checkered pr-2" aria-hidden="true"></i> {{ negociocrm.dataprevista | formatDataExtenso }} </span>
                        </div>
                        <div class="col-12 mt-2">
                            <v-label class="w-100" :metadata-field="metadata.negociocrm.probabilidade"></v-label>
                            <a v-if="!negociocrm.probabilidade && permiteAlteracao" style="cursor: pointer; color: #0091ea;" @click="handleEditNegocio"> Não Definido </a>
                            <span v-else class="lbl"> <i class="fa fa-percent pr-2" aria-hidden="true"></i> {{ negociocrm.probabilidade | formatValue(2) }} </span>
                        </div>
                        <div class="col-12 mt-2">
                            <label class="lbl-edit w-100">Origem do negócio</label>
                            <a v-if="!negociocrm.codorigem && permiteAlteracao" style="cursor: pointer; color: #0091ea;" @click="handleEditNegocio"> Definir a origem do negócio </a>
                            <span v-else class="lbl"> <i class="fa fa-flag-checkered pr-2" aria-hidden="true"></i> {{ negociocrm.origem[0].descricao }} </span>
                        </div>

                        <!-- SEGUIDORES -->
                        <div class="col-12 mt-5">
                            <span class="lbl-deal-subtitle">USUÁRIOS VINCULADOS</span>
                            <v-button v-if="permiteAlteracao" class="mb-2" :link="true" label="Adicione usuários vinculados" icon="fa-plus" :nb-btdef="false" @click="handleIncluirSeguidor"></v-button>
                            <span v-for="(item, index) in seguidores" :key="index">
                                    <a class="data-list pr-2"><i class="fa fa-user-circle pr-2" aria-hidden="true"></i> {{ item.usuario_nome }}</a>
                            </span>
                        </div>

                        <!-- ANEXOS -->
                        <div class="col-12 mt-5">
                            <span v-if="permiteAlteracao" class="lbl-deal-subtitle"><i class="fa fa-paperclip pr-2"></i>ANEXOS</span>
                            <v-button :link="true" label="Anexar um Arquivo" icon="fa-plus" :nb-btdef="false" @click="handleAnexarDocumento"></v-button>
                            <div class="mt-3">
                                <anexos-form ref="anexos" :params="{ ref: 'negociocrm', chaveref: negociocrm.codnegocio, showForm: false }" @change="handleChangeAnexos"></anexos-form>
                            </div>
                        </div>

                        <!-- LISTA DE PARTICIPANTES -->
                        <div class="col-12 mt-5 mb-5">
                            <span class="lbl-deal-subtitle"><i class="fa fa-users pr-2" aria-hidden="true"></i> PARTICIPANTES</span>
                            <v-button v-if="permiteAlteracao" class="mb-2" :link="true" label="Adicione participantes ao negócio" icon="fa-plus" @click="handleIncluirParticipante"></v-button>
                            <span v-for="(item, index) in participantes" :key="index">
                                <a :href="'#/crm/pessoa/' + item.codpessoa" class="data-list pr-2"><i class="fa fa-user pr-2" aria-hidden="true"></i> {{ item.pessoa[0].nome }}</a>
                            </span>
                        </div>
                    </div>

                </div>


                <!-- LADO DIREITO -->
                <div class="deal-form-right">
                    <!-- <div class="sticky">
                        <button type="button" class="close" style="" @click="closeForm()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div> -->
                    <tabs :tabs="tabs" :setActiveTab="activeTab" @onClickTab="changeTab"></tabs>

                    <div class="mb-2"></div>

                    <div style="overflow-x: auto; height: 100%;" v-if="tabPrincipal">
                        <!-- ANOTAÇÕES -->
                        <div class="mt-1">
                            <crm-notes :params="{ codnegocio: negociocrm.codnegocio, notes: notes }"></crm-notes>
                        </div>

                        <!-- AGENDA -->
                        <div class="mt-5">
                            <span class="lbl-deal-subtitle mb-2"><i class="fa fa-calendar pr-2"></i>ATIVIDADES PLANEJADAS</span>
                            <v-button :link="true" label="Criar uma atividade" icon="fa-plus" @click="handleIncluirAgenda"></v-button>
                        </div>
                        <crm-negocio-agenda ref="agenda" 
                            :params="{ negocio: negociocrm, organizacao: organizacao, pessoa: pessoa, listAgenda: negociocrm.agenda, listAgendaShow: agendaListPlanejada, delete: true, edit: true }"
                            @update="updateAgenda" @delete="updateAgenda"></crm-negocio-agenda>

                        <!-- ORÇAMENTO -->
                        <div class="mt-5">
                            <span class="lbl-deal-subtitle"><i class="fa fa-document pr-2"></i>ORÇAMENTOS</span>
                            <v-button v-if="orcamentoList.length == 0" :link="true" label="Criar um Orçamento" icon="fa-plus" @click="handleIncluirOrcamento"></v-button>
                        </div>
                        <div class="w-100 mt-3" v-for="(item, index) in orcamentoList" :key="index">
                            <div class="align-items-center" style="display: flex;">
                                <div class="col-1 text-center">
                                    <i class="fa fa-dollar lbl-deal-subtitle"></i>
                                </div>
                                <div class="card p-2 col-11">
                                    <div class="w-100">
                                        <span class="lbl-list pr-3"><i class="fa fa-calendar pr-2" aria-hidden="true"></i> {{ item.data | formatDataExtenso }}</span>
                                        <span class="lbl-list pr-3"><i class="fa fa-user-circle pr-2" aria-hidden="true"></i> Criado por {{ item.usuario_nome }}</span>
                                    </div>
                                    <div class="w-100">
                                        <span class="lbl-list pr-2">Número do Orçamento</span><span class="data-list">{{ item.ncotacao }}</span>
                                        <div class="w-100"></div>
                                        <span class="lbl-list pr-2">Valor Total</span><span class="data-list">{{ item.totger | formatValue(2) }}</span>
                                    </div>
                                    <div class="w-100" style="display: flex;">
                                        <v-button :link="true" label="Editar" icon="fa-pencil" @click="handleEditOrcamento(item.codpedv)"></v-button>
                                        <v-button :link="true" label="Visualizar" icon="fa-print" @click="handleImprimir(item.codpedv)"></v-button>
                                    <!-- <v-button title="Enviar Email" icon="fa-envelope-open" @click="handleEmailOrcamento(item.codpedv)"></v-button> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <!-- GUIA DE EMAILS -->
                    <div style="overflow-x: auto; height: 100%;" v-if="tabEmails">
                        <div class="col-12">
                            <div class="w-100 mt-3 mb-2">
                                <v-button label="Enviar um E-mail" icon="fa-envelope" :nb-btdef="false" @click="handleNovoEmail"></v-button>
                            </div>
                            <div class="mt-3 card p-2" v-if="novoEmail">
                                <crm-email :negocio="negociocrm" :pessoa="pessoa" @closeform="closeEmail"></crm-email>
                            </div>
                        </div>
                        <!-- LISTA DE EMAILS -->
                        <div class="col-12 mt-2 mb-2" v-for="(item, index) in emailList" :key="index">
                            <div v-if="item.codemail != showCodemail" class="align-items-center" style="display: flex;">
                                <div class="col-1 text-center">
                                    <i v-if="item.enviado=='S'" class="fa fa-arrow-right lbl-deal-subtitle"></i>
                                    <i v-else class="fa fa-envelope lbl-deal-subtitle"></i>
                                </div>
                                <div class="col-11 card p-2">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <!-- BOTAO EXPANDIR -->
                                            <v-button :link="true" icon="fa-expand" class="float-right" @click="showCodemail = item.codemail"></v-button>

                                            <span class="lbl-list float-right"><i class="fa fa-calendar pr-2" aria-hidden="true"></i> {{ item.data | formatDataHoraExtenso(true) }}</span>
                                            <span v-if="item.usuario_nome" class="card lbl-list px-2"><i class="fa fa-user-circle pr-2" aria-hidden="true"></i> {{ item.usuario_nome }}</span>
                                            <span v-if="item.attachments.length > 1" class="lbl float-right pr-2"><i class="fa fa-paperclip" aria-hidden="true"></i></span>

                                            <div v-if="item.enviado != 'S' && item.from_list.length > 0">
                                                <span class="lbl-list">De</span>
                                                <span class="email-address"><strong>{{ item.pessoa_nome }}</strong> {{ item.from_list[0].email }}</span>
                                            </div>

                                            <div v-if="item.enviado == 'S' && item.to_list.length > 0">
                                                <span class="lbl-list">Para</span>
                                                <span v-for="(to, index) in item.to_list" :key="index" class="email-address pr-2"><strong>{{ to.nome }}</strong> {{ to.email }}</span>
                                            </div>

                                        </div>
                                        <div class="col-md-12">
                                            <span v-if="item.visualizado=='S'" class="data-list w-100" style="cursor: pointer" @click="showCodemail = item.codemail">{{ item.subject }}</span>
                                            <span v-else class="data-list w-100" style="cursor: pointer" @click="showCodemail = item.codemail"><strong> {{ item.subject }} </strong></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="border border-info p-2" v-if="item.codemail == showCodemail">
                                <crm-email :codemail="item.codemail" @closeform="closeEmail"></crm-email>
                            </div>
                        </div>
                    </div>

                    <!-- AGENDA -->
                    <div style="overflow-x: auto; height: 100%;" v-if="tabAgenda">
                        <crm-negocio-agenda :params="{ listAgenda: agendaList }"></crm-negocio-agenda>
                    </div>

                    <!-- HISTORICO -->
                    <div style="overflow-x: auto; height: 100%;" v-if="tabHistorico">
                        <div class="col-12 mb-3" v-for="(item, index) in hist" :key="index">
                            <div class="row align-items-center">
                                <div class="col-1 text-center">
                                    <i class="fa fa-exchange"></i>
                                </div>
                                <div class="col-11">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <span class="data-list" v-if="item.tipo=='I'">Negócio criado</span>
                                            <!-- <span class="data-list" v-if="item.tipo=='U'">Negócio alterado</span> -->
                                            <div class="w-100"></div>
                                            <span class="data-list" v-if="item.tipo=='U'">{{ item.label }} de <strong>"{{ item.oldvalue }}"</strong> para <strong>"{{ item.newvalue }}"</strong> </span>
                                        </div>
                                        <div class="col-md-12">
                                            <span class="lbl-list pr-3 mb-3"><i class="fa fa-calendar pr-2" aria-hidden="true"></i> {{ item.data | formatDataHoraExtenso }}</span>
                                            <span class="lbl-list pr-3 mb-3"><i class="fa fa-user-circle pr-2" aria-hidden="true"></i> {{ item.usuario_nome }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>


    <crm-negocio-participantes v-if="showFormParticipantes" :params="{ negocio: negociocrm }" @closeform="handleCloseParticipante"></crm-negocio-participantes>
    <crm-negocio-seguidores v-if="showFormSeguidores" :params="{ negocio: negociocrm }" @closeform="handleCloseSeguidor"></crm-negocio-seguidores>
    <email-form v-if="showFormEmail" :index="codpedv" tipo="PEDV" title="Envio de Orçamento" @closeform="closeFormEmail" @send="handleSendEmail"></email-form>
    <crm-negocio-motivo-form v-if="showFormMotivo" :params="{ negocio: negociocrm }" @closeform="closeFormMotivo"></crm-negocio-motivo-form>
    <crm-negocio-novo-form v-if="showFormNegocio" :index="negociocrm.codnegocio" :params="paramsNegocio" :funil="funil" @closeform="closeNovoNegocio"></crm-negocio-novo-form>
    <crm-pessoa-novo-form v-if="showFormPessoa" :index="pessoa.codpessoa" @closeform="closeFormPessoa"></crm-pessoa-novo-form>
    <crm-org-novo-form v-if="showFormOrg" :transformarPart="incluirOrcamento" :index="organizacao.codorg" @closeform="closeFormOrg"></crm-org-novo-form>
</div>
</div>

</template>

<style scoped>





.typeahead {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1051;
    list-style: none;
    background-color: #fff;
    border: 1px solid #ccc;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    border-radius: 6px;
    -webkit-box-shadow: 0 5px 10px rgba(0,0,0,0.2);
    -moz-box-shadow: 0 5px 10px rgba(0,0,0,0.2);
    box-shadow: 0 5px 10px rgba(0,0,0,0.2);
}


</style>


// WEBPACK FOOTER //
// src/forms-crm/crm-negocio-form.vue